var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15653_6097)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15653_6097)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 0.818359H25.8823V17.182H1.05469V0.818359Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 0.818359H25.8823V5.72745H1.05469V0.818359Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 12.2729H25.8823V17.182H1.05469V12.2729Z",
  fill: "#006600"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1406 13.8582L10.3501 13.9604L15.785 5.67636C16.0992 5.61499 16.2738 5.34909 16.4484 5.08318C16.5648 4.89909 17.0303 4.1934 17.2281 3.27295C16.676 3.70412 16.2081 4.21201 15.8432 4.77636C15.6686 5.04227 15.4941 5.30818 15.5755 5.58431L10.1406 13.8582Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.3169 3.13525L17.2852 3.28253C17.0937 4.17339 16.654 4.86454 16.5154 5.08255C16.5094 5.09195 16.504 5.10048 16.4991 5.1081L16.4989 5.10846L16.4971 5.11117C16.4109 5.24245 16.3214 5.37883 16.2131 5.48984C16.1088 5.5968 15.984 5.68355 15.8229 5.72095L10.3718 14.0297L10.0605 13.8777L15.5134 5.57651C15.4769 5.43252 15.5034 5.29296 15.5585 5.15918C15.6156 5.0207 15.705 4.88449 15.7913 4.75309L15.7925 4.75118C15.7925 4.75113 15.7926 4.75108 15.7926 4.75103C16.1607 4.18188 16.6325 3.66966 17.1894 3.23481L17.3169 3.13525ZM17.135 3.41691C16.6446 3.82088 16.2261 4.28767 15.8937 4.80171L15.8935 4.802C15.8056 4.93583 15.7212 5.06478 15.668 5.19399C15.6151 5.32228 15.5949 5.44676 15.6318 5.57157L15.6377 5.59183L10.2205 13.8388L10.3282 13.8914L15.7473 5.63141L15.7723 5.62653C15.9131 5.59904 16.025 5.52554 16.1248 5.42328C16.2253 5.32027 16.3098 5.19185 16.3976 5.05808C16.4023 5.05062 16.4076 5.04233 16.4134 5.03321C16.5429 4.82962 16.9328 4.21664 17.135 3.41691Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1406 13.8582L10.3501 13.9604L15.785 5.67636C16.0992 5.61499 16.2738 5.34909 16.4484 5.08318C16.5648 4.89909 17.0303 4.1934 17.2281 3.27295C16.676 3.70412 16.2081 4.21201 15.8432 4.77636C15.6686 5.04227 15.4941 5.30818 15.5755 5.58431L10.1406 13.8582Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9016 6.54585H15.6796C15.3305 5.72767 14.1667 4.09131 13.4684 4.09131C12.7702 4.09131 11.6064 5.72767 11.2572 6.54585H1.04688V11.4549H11.2572C11.6064 12.2731 12.7702 13.9095 13.4684 13.9095C14.1667 13.9095 15.3305 12.2731 15.6796 11.4549H25.9016V6.54585Z",
  fill: "#BB0000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6796 11.4545C16.0287 10.6363 16.2614 9.81814 16.2614 8.99996C16.2614 8.18177 16.0287 7.36359 15.6796 6.54541C15.3304 7.36359 15.0977 8.18177 15.0977 8.99996C15.0977 9.81814 15.3304 10.6363 15.6796 11.4545Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4694 9.61399C13.7265 9.61399 13.9349 9.33926 13.9349 9.00036C13.9349 8.66145 13.7265 8.38672 13.4694 8.38672C13.2123 8.38672 13.0039 8.66145 13.0039 9.00036C13.0039 9.33926 13.2123 9.61399 13.4694 9.61399Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5859 9.59375C13.5859 9.59375 14.0515 10.4119 14.0515 11.7415C14.0515 13.071 13.5859 13.8892 13.5859 13.8892V9.59375Z",
  fill: "white"
})));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15653_6097"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15653_6097"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818359)"
})));
function SvgSw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSw);
export default __webpack_public_path__ + "static/media/sw.dbaa7271.svg";
export { ForwardRef as ReactComponent };